if(!customElements.get("carousel-component")) {
    class Carousel extends HTMLElement {
      constructor() {
        super();
        this.carouselElement = this;
        
        this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
        this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
        this.tabletPerPage = this.carouselElement.dataset['tabletperpage'] || 3;
        this.focus = this.carouselElement.dataset['focus'];
        this.type = this.carouselElement.dataset['type'];
        this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
        this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
        this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 10000;
        this.direction = this.carouselElement.dataset['direction'] || 'ltr';
        this.perMove = this.carouselElement.dataset['permove'] || 1;
        this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
        this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
        this.tabletPaddingRight = this.carouselElement.dataset['tabletpaddingright'] || '0';
        this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
        this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';

        this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
        this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
        this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
        this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
        this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
        this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
        this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
        this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
        this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
        this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;
  
        this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
        this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;

        if (!this.carouselElement.classList.contains('splide')) return;
        this.initCarousel();
      }
     
      initCarousel() {
        const placeholders = document.querySelectorAll('.splide-placeholder__image');
        const initializedClass = document.querySelectorAll('.custom-initialization');

        if (placeholders.length > 0) {
          placeholders.forEach(el => {
            el.style.display = 'none';
          });
        }

        if(initializedClass.length > 0) {
          initializedClass.forEach(el => {
            el.classList.remove('custom-initialization');
          });
        }

        if (this.destroyOnMobile && this.destroyOnDesktop) return;
        // this.carousel = new Splide(this.carouselElement, {
        //   perPage: this.desktopPerPage,
        //   ...(this.type ? { type: this.type } : {}),
        //   ...(this.focus ? { focus: this.focus } : {}),
        //   autoplay: this.autoplay,
        //   interval: this.autoplaySpeed,
        //   gap: this.gap,
        //   lazyLoad: 'nearby',
        //   snap: true,
        //   arrows: this.showarrows,
        //   pagination: this.showdots,
        //   isNavigation: this.isNavigation,
        //   drag: !this.disableDrag,
        //   direction: this.direction,
        //   destroy: this.destroyOnDesktop,
        //   padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        //   omitEnd : this.omitEnd,
        //   perMove: this.perMove,
        //   breakpoints: {
        //     750: {
        //       padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
        //       perPage: this.mobilePerPage,
        //       arrows: this.showarrowsonmobile,
        //       pagination: this.showdotsonmobile,
        //       gap: this.gapMobile,
        //       destroy: this.destroyOnMobile,
        //     }
        //   },
        // });

        this.carousel = new Splide(this.carouselElement, {
  perPage: this.desktopPerPage,
  ...(this.type ? { type: this.type } : {}),
  ...(this.focus ? { focus: this.focus } : {}),
  autoplay: this.autoplay,
  interval: this.autoplaySpeed,
  gap: this.gap,
  lazyLoad: 'nearby',
  snap: true,

  // ✅ Desktop behavior
  arrows: true,
  pagination: false,

  isNavigation: this.isNavigation,
  drag: !this.disableDrag,
  direction: this.direction,
  destroy: this.destroyOnDesktop,
  padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
  omitEnd: this.omitEnd,
  perMove: this.perMove,

  breakpoints: {
    750: {
      padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
      perPage: this.mobilePerPage,
      gap: this.gapMobile,

      // ✅ Mobile behavior
      arrows: false,
      pagination: true,

      destroy: this.destroyOnMobile,
    }
  },
});

        let wheelLocked = false;

        this.carouselElement.addEventListener(
          'wheel',
          (event) => {
            const HORIZONTAL_THRESHOLD = 40;

            if (
              Math.abs(event.deltaX) > Math.abs(event.deltaY) &&
              Math.abs(event.deltaX) > HORIZONTAL_THRESHOLD
            ) {
              event.preventDefault();

              if (wheelLocked) return;
              wheelLocked = true;

              this.carousel.go(event.deltaX > 0 ? '>' : '<');

              setTimeout(() => {
                wheelLocked = false;
              }, 400);
            }
          },
          { passive: false }
        );
    
        // if (!this.carouselElement.closest('.product') && window.innerWidth > 749) { 
        //   this.carouselElement.addEventListener('wheel', (event) => {
        //     if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        //       event.preventDefault();
        //       if (!this.carousel.Components.Controller.isBusy()) {
        //         if (event.deltaX > 0) {
        //           this.carousel.go('>');
        //         } else if (event.deltaX < 0) {
        //           this.carousel.go('<');
        //         }
        //         console.log(event.deltaX);
        //         console.log(event.deltaY);
        //       }
        //     }
        //   });
        // }

        if (this.sync) {
          setTimeout(() => {
            this.initCarouselSync()
          } , 100)
        } else {
          this.carousel.mount();
  
          if (this.refresh)
            this.carousel.refresh()
        }
      }
  
      initCarouselSync() {
        this.syncElement = document.querySelector(this.sync);
        this.direction = this.syncElement.dataset['direction'] || 'ltr'
    
        this.carouselSync = new Splide(this.sync, {
          updateOnMove: true,
          perPage: this.syncElement.dataset['desktopperpage'] || 4,
          type: this.syncElement.dataset['type'] || 'loop',
          focus: this.syncElement.dataset['focus'] || 'center',
          isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
          pagination: false,
          lazyLoad: 'nearby',
          gap: this.gap,
          snap: true,
          arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
          drag: true,
          // Conditional configuration for 'ttb' direction
          ...(this.direction === 'ttb' && {
            height: this.getPrimarySlideFirstImageHeight(),
            direction: 'ttb',
            autoHeight: true,
          }),
          breakpoints: {
            767: {
              height: 'auto',
              direction: 'ltr',
              gap: this.gapMobile,
              arrows: this.showarrowsonmobile
            }
          },
        });
        
    
        this.carousel.sync(this.carouselSync);
        this.carousel.mount();
        this.carouselSync.mount();
      };
    
      refreshSlider() {
        this.carousel.refresh();
        if (this.carouselSync) {
          this.carouselSync.refresh();
        }
      }
  
      getPrimarySlideFirstImageHeight() {
        const image = this.querySelector('.splide__list img');
        const containerWidth = this.querySelector('.splide__list').clientWidth;
        const originalWidth = image.getAttribute('width');
        const originalHeight = image.getAttribute('height');
        return (containerWidth / originalWidth) * originalHeight;
      }
    }
    window.Carousel = Carousel;
  customElements.define('carousel-component', Carousel);
  }